var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7123 19.0372C16.7333 18.0557 15.4049 17.5027 14.0187 17.4995C13.326 17.4961 12.6395 17.6303 11.999 17.8943C11.3585 18.1582 10.7769 18.5467 10.2877 19.0372M24.5 13.9995C24.5 15.3784 24.2284 16.7438 23.7007 18.0177C23.1731 19.2916 22.3996 20.4491 21.4246 21.4241C20.4496 22.3991 19.2921 23.1726 18.0182 23.7002C16.7443 24.2279 15.3789 24.4995 14 24.4995C12.6211 24.4995 11.2557 24.2279 9.98182 23.7002C8.70791 23.1726 7.55039 22.3991 6.57538 21.4241C5.60036 20.4491 4.82694 19.2916 4.29926 18.0177C3.77159 16.7438 3.5 15.3784 3.5 13.9995C3.5 11.2147 4.60625 8.54402 6.57538 6.57489C8.54451 4.60576 11.2152 3.49951 14 3.49951C16.7848 3.49951 19.4555 4.60576 21.4246 6.57489C23.3938 8.54402 24.5 11.2147 24.5 13.9995ZM11.375 11.3745C11.375 11.8575 11.179 12.2495 10.9375 12.2495C10.696 12.2495 10.5 11.8575 10.5 11.3745C10.5 10.8915 10.696 10.4995 10.9375 10.4995C11.179 10.4995 11.375 10.8915 11.375 11.3745ZM10.9375 11.3745H10.9468V11.392H10.9375V11.3745ZM17.5 11.3745C17.5 11.8575 17.304 12.2495 17.0625 12.2495C16.821 12.2495 16.625 11.8575 16.625 11.3745C16.625 10.8915 16.821 10.4995 17.0625 10.4995C17.304 10.4995 17.5 10.8915 17.5 11.3745ZM17.0625 11.3745H17.0718V11.392H17.0625V11.3745Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.011fa69419e73ff0fa2c682deb261abb.svg";
export { ForwardRef as ReactComponent };